
export class TreatmentareasAzModule {

    constructor() {

        if ($("#component-treatmentarea-az").length > 0) {
            this.properties();
            this.init(); 
        }       
    }

    properties() {
        /* treatmentLinks global variable */
        this.data =  treatmentLinks;
    }
    
    buildAzBar(letter, searchBarRow) {

        let _this = this;
        $(searchBarRow).html("");
        $(".treatmentareaaz__search-term").val("");
        $(".treatmentareaaz__list-default .treatmentareaaz__list").html("");
        $(".treatmentareaaz__list-default .treatmentareaaz__list-header").html(`Results for '${letter.toUpperCase()}':`);
        $.each(_this.data, function(i, item) {
            if (_this.searchCriteriaIsMatched(item, letter)) {
                let letterClassName = `letter-${item.Text.substring(0,1).toLowerCase()}`;

                if (item.Text.substring(1,2) !== "-") {
                    let subLetterClassName = `subletter-${item.Text.substring(0,2).toLowerCase()}`;
                    if (!$("." + subLetterClassName).length) {                       
                        let alphaTemplate = `<div class='col-2 ${letterClassName} ${subLetterClassName}'><a class='alpha-link' href='${item.Url}'>${item.Text.substring(0,1).toLowerCase()}${item.Text.substring(1,2).toLowerCase()}</a></div>`;
                        $(searchBarRow).append(alphaTemplate); 
                    }
                }
                
                _this.addToAlphaResults(item);         
            }        
        });

        let selectedLetterClassName = `.letter-${letter}`;
        var letterLength = $(selectedLetterClassName).length;
        let remainder = (letterLength % 6);
        
        if (remainder > 0) {
            let emptyItems = 6 - remainder;
            for (var i = 0; i < emptyItems; i++) { 
                $(".treatmentareaaz__subletters").append(`<div class='col-2'><span class='alpha-empty'></span></div>`);     
            }
        }
    }

    addToAlphaResults(item) {
        $(".treatmentareaaz__list-default .treatmentareaaz__list").append(`<li><a href="${item.Url}">${item.Text}</a></li>`); 
    }

    addToSearchResults(item) {
        var  isMobile = $(".treatmentareaaz__list-mobile").is(":visible");
        if (isMobile) {
            $(".treatmentareaaz__list-mobile .treatmentareaaz__list").append(`<li><a href="${item.Url}">${item.Text}</a></li>`); 
        } else {
            $(".treatmentareaaz__list-default .treatmentareaaz__list").append(`<li><a href="${item.Url}">${item.Text}</a></li>`); 
        }
    } 

    searchCriteriaIsMatched(item, letter) {
        let length = letter.length;        
        let isMatch = item.Text.substring(0,length).toLowerCase() == letter.toLowerCase();
        return isMatch;
    }

    registerAlphaLinkClick() {      

        $("body").on("click", ".alpha-link", (e) => {            
            e.preventDefault();
                    
            let $this = $(e.currentTarget);
            let isSubletter = $this.parent().parent().hasClass("treatmentareaaz__subletters");
            let searchBarRow = $this.parent().parent().next(".treatmentareaaz__subletters");

            if (!isSubletter) {
                $(".alpha-link").removeClass("is-on");
                $this.addClass("is-on");           
                $(".treatmentareaaz__subletters").removeClass("is-on");                           
                $(searchBarRow).addClass("is-on");
            } else {                           
                $(".treatmentareaaz__subletters .alpha-link").removeClass("is-on");
                $this.addClass("is-on");
            }

            let letter = $this.text().toLowerCase();
            this.buildAzBar(letter, searchBarRow);
            this.showHideContent("alpha");  
        });

    }

    registerSearchTermSubmit() {        

        document.querySelector(".treatmentareaaz__search-bar form").addEventListener("submit", (e) => {

                e.preventDefault();
                $(".treatmentareaaz__list-default .treatmentareaaz__list").html("");
                let letter = $(".treatmentareaaz__search-term").val();
                if (letter.length > 2) {
                    for (var item of this.data) {               
                        if (item.Text.includes(letter)) this.addToSearchResults(item);
                    }
                    this.showHideContent("search"); 
                }
               
        });
    }

    registerSearchTermTypeahead() {
        $(".treatmentareaaz__search-term").on('input', (e) => { 

            let $this = $(e.currentTarget);
            var letter = $this.val();
            if (letter.length < 3) {
                this.showHideContent("default"); 
                return;
            }
          
            var  isMobile = $(".treatmentareaaz__list-mobile").is(":visible");
            if (isMobile) {
                $(".treatmentareaaz__list-mobile .treatmentareaaz__list-header").html(`Results for '${letter}':`); 
                $(".treatmentareaaz__list-mobile .treatmentareaaz__list").html('');
            } else {
                $(".treatmentareaaz__list-default .treatmentareaaz__list-header").html(`Results for '${letter}':`); 
                $(".treatmentareaaz__list-default .treatmentareaaz__list").html('');
            }
            for (var item of this.data) {
               
                if (this.searchCriteriaIsMatched(item, letter)) {
                    this.addToSearchResults(item);    
                }
            }

            this.showHideContent("search");

        });
    }

    registerViewAllButton() {

        $("body").on("click", ".js-treatmentareaaz__toggle", (e) => { 

            e.preventDefault();
            let treatmentareaazToggle = document.querySelector(".treatmentareaaz__showall");
            if (this.isHidden(treatmentareaazToggle)) {
                $(".treatmentareaaz__showall").removeClass("hide").addClass("display-flex");
                $(".treatmentareaaz__showall-show").hide();
                $('html, body').animate({
                    scrollTop: $("#treatmentareaaz__showall").offset().top
                }, 0);
            } else {
                $(".treatmentareaaz__showall").removeClass("display-flex").addClass("hide");
                $(".treatmentareaaz__showall-show").show();
                $('html, body').animate({
                    scrollTop: $("body").offset().top
                }, 0);          
            }

        });

    }

    registerCloseSearchButton() {
        document.querySelector(".treatmentareaaz__search-close").addEventListener("click", (e) => { 
            e.preventDefault();
            $(".treatmentareaaz__search-term").val("");
            this.showHideContent("default");
        });
    }

    isHidden(el) {
        return (el.offsetParent === null)
    }

    showHideContent(content) {
        
        var  isMobile = $(".treatmentareaaz__list-mobile").is(":visible");
        if (content === "default") {
            $(".treatmentareaaz__introduction").show();
            $(".treatmentareaaz__list-header").hide();
            $(".treatmentareaaz__list").hide();
            $(".alpha-link").removeClass("is-on");         
            $(".treatmentareaaz__subletters").removeClass("is-on");           
        }

        if (content === "alpha") {

            $(".treatmentareaaz__search-term").val();
            $(".treatmentareaaz__introduction").hide();
            $(".treatmentareaaz__list-mobile .treatmentareaaz__list-header").hide();
            $(".treatmentareaaz__list-mobile .treatmentareaaz__list").hide();
            $(".treatmentareaaz__list-default .treatmentareaaz__list-header").show();
            $(".treatmentareaaz__list-default .treatmentareaaz__list").show();           
        }

        if (content === "search") {

            $(".treatmentareaaz__introduction").hide();
            if (isMobile) {
                $(".treatmentareaaz__list-mobile .treatmentareaaz__list-header").show();
                $(".treatmentareaaz__list-mobile .treatmentareaaz__list").show();
                $(".treatmentareaaz__list-default .treatmentareaaz__list-header").hide();
                $(".treatmentareaaz__list-default .treatmentareaaz__list").hide();
            } else {
                $(".treatmentareaaz__list-mobile .treatmentareaaz__list-header").hide();
                $(".treatmentareaaz__list-mobile .treatmentareaaz__list").hide();
                $(".treatmentareaaz__list-default .treatmentareaaz__list-header").show();
                $(".treatmentareaaz__list-default .treatmentareaaz__list").show();
            }

            $(".alpha-link").removeClass("is-on");         
            $(".treatmentareaaz__subletters").removeClass("is-on");             
        }
    }

    mobileAccordion() {

        $(".treatmentareaaz__showall-text").on('click', (e) => { 

            let $this = $(e.currentTarget);
            let isCurrentlyOn = $this.hasClass("is-on");
            $(".treatmentareaaz__showall-text").removeClass('is-on');
            let currentContent = $this.find('.treatmentareaaz__showall-content');
            let isHidden = currentContent.is(":hidden");         
            if (isHidden && !isCurrentlyOn){
              //  $this.find('.treatmentareaaz__showall-content').show();
                $this.addClass('is-on');
            } else {
              //  $this.find('.treatmentareaaz__showall-content').hide();
                $this.removeClass('is-on');
            }
        });
    }

    init() {
        this.properties();
        this.registerAlphaLinkClick();
        this.registerSearchTermTypeahead();
        this.registerSearchTermSubmit();
        this.registerViewAllButton();
        this.registerCloseSearchButton();
        this.mobileAccordion();
    }
}
  
    




